export default __webpack_public_path__ + "static/media/DSC05838.a521e818.jpg";